import React, { useEffect, useLayoutEffect } from "react"
import useInput from "../../../hooks/useInput"
import InputMessage from "../../ui/inputError"
import InputLabel from "../../ui/inputLabel"
import { strings } from "../../../assets/config/translations"
import './index.scss'

const TextInput = (props) => {

    const { ref ,  bind, error, displayError, disabled} = useInput({...props})
    const {register, deregister} = props 
        
    useLayoutEffect(() => {
        if (register){
            register(props.name, ref)
        }
        return () => {
            if (deregister){
                deregister(props.name)
            }        }
    }, [])

    // Change to onchange on rest
    useEffect(() => {
        if (props.onRender) {
            props.onRender()
        }
    }, [bind.value])

    
    return (
        <div className={`input input-text  ${props.className || ''} ${error && displayError ? 'error' : ''} ${props.disabled ? 'disabled' : ''}`}>
            <InputLabel {...props}/>
            <div className="group">
                <input
                    id={props.name}
                    type="text"
                    {...bind}
                    {...props}
                    
                />
                {props.trailingLabel &&
                <div className="trailing-label">
                    <p className="text lead">{props.trailingLabel}</p>
                </div>}
            </div>

            <InputMessage displayError={displayError} error={strings[error] || error} message={props.message} />
        </div>
    )
}

export default TextInput;